import React from "react";
import styled from "styled-components";

export interface BlockchainAddressProps extends React.HTMLAttributes<HTMLSpanElement> {
    address: string;
    short?: boolean;
    length?: number;
    children?: React.ReactNode;
    // Додаткові props для сумісності
    type?: string;
    variant?: string;
    ellipsis?: "start" | "middle" | "end";
}

const BlockchainAddressRoot = styled.span`
    font-family: monospace;
    word-break: break-all;
`;

export const BlockchainAddress: React.FC<BlockchainAddressProps> = ({
    address,
    short = false,
    length = 6,
    children,
    ellipsis,
    ...props
}) => {
    let displayAddress = address;
    
    if (short || ellipsis) {
        const len = length || 6;
        if (ellipsis === "middle") {
            displayAddress = `${address.slice(0, len)}...${address.slice(-len)}`;
        } else if (ellipsis === "start") {
            displayAddress = `...${address.slice(-len)}`;
        } else if (ellipsis === "end") {
            displayAddress = `${address.slice(0, len)}...`;
        } else {
            displayAddress = `${address.slice(0, len)}...${address.slice(-len)}`;
        }
    }

    return <BlockchainAddressRoot {...props}>{children || displayAddress}</BlockchainAddressRoot>;
};

export default BlockchainAddress;


